import React from "react";
import { ForecastTable } from "../Table";

export const Worked = () => {
  return <ForecastTable workedTime />;
};
